(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gamaro-promo-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gamaro-promo-countdown')) {
    class GamaroPromoCountdown extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.deadline = null;
        this.timer = this.querySelector('[data-timer]');
        this.active = this.querySelector('[data-active]');
        this.expired = this.querySelector('[data-expired]');
        this.editor = this.dataset.editor === 'true';
        this.onVisibility = () => {
          this.stop();
          if (!document.hidden && this.deadline) this.run();
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.querySelectorAll('.gamaro-promo__notice').forEach((notice) => { notice.hidden = true; });
        this.active.hidden = false;
        this.expired.hidden = true;
        if (this.dataset.enabled !== 'true') {
          this.hidden = !this.editor;
          this.active.hidden = true;
          this.notice('[data-hidden-note]');
          return;
        }
        if (this.dataset.countdown !== 'true') {
          this.hidden = false;
          return;
        }
        this.deadline = this.parseDeadline();
        if (!Number.isFinite(this.deadline)) {
          this.deadline = null;
          this.hidden = !this.editor;
          if (this.timer) this.timer.hidden = true;
          this.notice('[data-invalid]');
          return;
        }
        this.fields = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map((unit) => [unit, this.querySelector(`[data-${unit}]`)]));
        this.run();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      parseDeadline() {
        const date = this.dataset.date || '';
        const time = this.dataset.time || '';
        const offset = this.dataset.offset || '';
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return NaN;
        if (!['-02:00', '-03:00', '-04:00', '-05:00', '+00:00'].includes(offset)) return NaN;
        const calendar = new Date(`${date}T00:00:00Z`);
        if (!Number.isFinite(calendar.getTime()) || calendar.toISOString().slice(0, 10) !== date) return NaN;
        return Date.parse(`${date}T${time}:00${offset}`);
      }

      run() {
        this.stop();
        if (this.update() && !document.hidden) this.interval = window.setInterval(() => this.update(), 1000);
      }

      update() {
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        if (remaining === 0) {
          this.stop();
          this.timer.hidden = true;
          this.active.hidden = true;
          const showMessage = this.dataset.expiry === 'message' && this.expired.textContent.trim().length > 0;
          this.expired.hidden = !showMessage;
          this.hidden = !showMessage && !this.editor;
          if (!showMessage) this.notice('[data-expired-note]');
          return false;
        }
        const withDays = this.dataset.showDays === 'true';
        const values = {
          days: Math.floor(remaining / 86400),
          hours: withDays ? Math.floor(remaining / 3600) % 24 : Math.floor(remaining / 3600),
          minutes: Math.floor(remaining / 60) % 60,
          seconds: remaining % 60,
        };
        for (const [unit, value] of Object.entries(values)) {
          const field = this.fields[unit];
          const formatted = String(value).padStart(2, '0');
          if (field && field.textContent !== formatted) field.textContent = formatted;
        }
        this.timer.hidden = false;
        this.hidden = false;
        return true;
      }

      notice(selector) {
        const notice = this.querySelector(selector);
        if (this.editor && notice) notice.hidden = false;
      }

      stop() {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }
    customElements.define('gamaro-promo-countdown', GamaroPromoCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
